import { Row, Col, Button } from "react-bootstrap";
import CartItem from "./cartitem";
import Link from "next/link";
import { ShrimBox, ShrimLine } from "../shared/loading";
import { Blob_Base_Url, staticImages } from "../../utils/static";
import RentalDuration from "./duration";
import PickupLocations from "./pickup";

const CartDetail = (props) => {
  const { items, summary } = props;
  return (
    <div className="cart-detail">
      <div className="d-flex justify-content-between mb-3 mt-2">
        {items ? (
          <>
            <p className="fw-bold">My Shopping Cart ({items?.length || 0})</p>
            <p className="fw-bold">Total Charge : ${summary?.total}</p>
          </>
        ) : (
          <ShrimLine className="py-3" />
        )}
      </div>

      {items ? (
        items.length === 0 ? (
          <EmptyCart />
        ) : (
          items?.map((x) => <CartItem {...props} data={x} />)
        )
      ) : (
        <ShrimBox className={"rounded-8"} />
      )}
      <RentalDuration />
      <PickupLocations />
    </div>
  );
};

const EmptyCart = () => (
  <Row className="align-items-center h-100 py-3 mt-1">
    <Col>
      <img src={Blob_Base_Url + staticImages.sadGirl} className="w-100" />
    </Col>
    <Col className="text-center">
      <h1 className="fw-bold fs-4">Shopping Cart</h1>
      <p>Your Cart Is Empty, Let's Shop</p>
      <Link href="/search">
        <Button
          className="col-md-5 py-2 rounded-8 fw-bold ls2 font-md"
          variant="dark"
        >
          SHOP NOW
        </Button>
      </Link>
    </Col>
  </Row>
);

export default CartDetail;
